import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ContactUserPopoverIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M12.667 3.154H9.88A2.007 2.007 0 0 0 8 1.82c-.867 0-1.6.56-1.88 1.334H3.333C2.6 3.154 2 3.754 2 4.487v9.333c0 .734.6 1.334 1.333 1.334h9.334c.733 0 1.333-.6 1.333-1.334V4.487c0-.733-.6-1.333-1.333-1.333ZM8 2.987a.5.5 0 0 1 .367.167c.08.086.133.206.133.333 0 .273-.227.5-.5.5a.504.504 0 0 1-.5-.5c0-.127.053-.247.133-.333A.5.5 0 0 1 8 2.987Zm4.667 10.833H3.333V4.487h9.334v9.333ZM8 5.154c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2ZM8 7.82a.669.669 0 0 1-.667-.666c0-.367.3-.667.667-.667.367 0 .667.3.667.667 0 .366-.3.666-.667.666Zm-4 4.314v1.02h8v-1.02c0-1.667-2.647-2.387-4-2.387-1.353 0-4 .713-4 2.387Zm1.54-.314c.46-.373 1.587-.746 2.46-.746s2.007.373 2.46.746H5.54Z" />
  </Icon>
);

export default memo(ContactUserPopoverIcon);
